import Endpoints from '../../constants/Endpoints';
import axios from '../axiosInstance';
import { ApiResult } from '../types';

const getAll = async (params: any) => {
  const { page, pageSize, ...rest } = params;

  const config = {
    params: { ...rest, offset: page * pageSize, limit: pageSize },
  };

  return await axios.get<never, ApiResult<any>>(Endpoints.TransactionRequest.GetAll, config);
};

const getExport = async (params: any) => {
  const { pageSize, page, ...rest } = params;

  const payload = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
  };
  return await axios.get<any, ApiResult<any>>(Endpoints.TransactionRequest.Export, payload);
};

const getApprovalHistory = async ({ id }: { id: string }) => {
  return await axios.get<any, ApiResult<any>>(Endpoints.TransactionRequest.GetApprovalHistory, {
    params: { requestId: id },
  });
};

const approve = async (params: any, config?: any) => {
  const res = await axios.post(Endpoints.TransactionRequest.Approve, params, config);

  return res;
};

const reject = async (params: any, config?: any) => {
  const res = await axios.post(Endpoints.TransactionRequest.Reject, params, config);

  return res;
};

const TransactionRequest = {
  getAll,
  getExport,
  getApprovalHistory,
  approve,
  reject,
};

export default TransactionRequest;
